import React, {FC, useState} from 'react';
import {Icon} from './Icon';

interface BookmarkButtonProps {
    preSelected: boolean
}

export const BookmarkButton: FC<BookmarkButtonProps> = ({preSelected}: BookmarkButtonProps) => {
    const [selected, setSelected] = useState(preSelected);
    return (
        <>
            <div
                // onClick={() => setSelected(!selected)}
                className="cursor-pointer">
                <Icon.Bookmark
                    className={` wh-4  ${
                        preSelected
                            ? 'text-brand-1 fill-current'
                            : 'text-brand-1 stroke-current stroke-2 '
                    }`}
                />
            </div>
        </>
    );
};
